import Vue from 'vue'
import VueRouter from 'vue-router'

import NotFound from '@/views/NotFound.vue'
import Home from '@/views/Home.vue'
import LandingCar from '@/views/LandingCar.vue'
import LandingBoat from '@/views/LandingBoat.vue'
import LandingMotorcycle from '@/views/LandingMotorcycle.vue'
import LandingHome from '@/views/LandingHome.vue'
import SelectPolicy from '@/views/SelectPolicy.vue'
import SelectPlan from '@/views/SelectPlan.vue'
import RenewQuote from '@/views/RenewQuote.vue'
import PaymentInsuranceSuccess from '@/views/PaymentInsuranceSuccess.vue'
import notifyApi from '@/utils/notifyApi.js'
import NoPolicyFound from '@/views/NoPolicyFound.vue'

import MobilePhone from '@/views/userPolicyDataForms/MobilePhone.vue'
import PolicyNumber from '@/views/userPolicyDataForms/PolicyNumber.vue'
import QidNumber from '@/views/userPolicyDataForms/QidNumber.vue'

import WizardRenewMotor from '@/views/WizardRenewMotor'
import { INITIAL_TRANS_ID_STORE_NAME } from '@/constants/constants.ts'
Vue.use(VueRouter)

const lang = process.env.VUE_APP_I18N_LOCALE
const path = process.env[`VUE_APP_${lang.toUpperCase()}_BASE_URL`] || process.env.VUE_APP_PUBLIC_PATH
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    props: true
  },
  {
    path: '/car',
    name: 'LandingCar',
    component: LandingCar,
    props: true
  },
  {
    path: '/boat-yacht',
    name: 'LandingBoat',
    component: LandingBoat,
    props: true
  },
  {
    path: '/motorcycle',
    name: 'LandingMotorcycle',
    component: LandingMotorcycle,
    props: true
  },
  {
    path: '/home',
    name: 'LandingHome',
    component: LandingHome,
    props: true
  },
  {
    path: '/select-policy',
    name: 'SelectPolicy',
    component: SelectPolicy,
    props: true
  },
  {
    path: '/select-plan',
    name: 'SelectPlan',
    component: SelectPlan
  },
  {
    path: '/quote',
    name: 'RenewQuote',
    component: RenewQuote
  },
  {
    path: '/insurance-result',
    name: 'PaymentInsuranceResult',
    component: PaymentInsuranceSuccess
  },

  /**
   * Make separate URL for all the cases.
   * Case 1: https://<domain>/en/insurance-renewal/policy-not-found-link?<parameters>
   * Case 2: https://<domain>/en/insurance-renewal/policy-renewed?<parameters>
   * Case 3: https://<domain>/en/insurance-renewal/policy-active?<parameters>
   * Case 4: https://<domain>/en/insurance-renewal/policy-active-soon?<parameters>
   * Case 5: https://<domain>/en/insurance-renewal/no-policies-list?<parameters>
   * Case 6: https://<domain>/en/insurance-renewal/policy-not-found?<parameters>
   * Case 7: https://<domain>/en/insurance-renewal/mobile-qid-policy-not-found?<parameters>
   *
   * details: https://qicbizdev.atlassian.net/browse/QIC-368
   */

  { // case 1
    path: '/policy-not-found-link',
    name: 'PolicyNotFoundLink',
    component: NoPolicyFound,
    props: true
  },
  { // case 2
    path: '/policy-renewed',
    name: 'PolicyAlreadyRenewed',
    component: NoPolicyFound,
    props: true
  },
  { // case 3
    path: '/policy-active',
    name: 'PolicyActive',
    component: NoPolicyFound,
    props: true
  },
  { // case 4
    path: '/policy-active-soon',
    name: 'PolicyActiveSoon',
    component: NoPolicyFound,
    props: true
  },
  { // case 5
    path: '/no-policies-list',
    name: 'NoPoliciesList',
    component: NoPolicyFound,
    props: true
  },
  { // case 6
    path: '/policy-not-found',
    name: 'PolicyNotFound',
    component: NoPolicyFound,
    props: true
  },
  { // case 7
    path: '/mobile-qid-not-found',
    name: 'MobileQidNotFound',
    component: NoPolicyFound,
    props: true
  },
  {
    path: '/mobile-phone',
    name: 'MobilePhone',
    component: MobilePhone
  },
  {
    path: '/policy-number',
    name: 'PolicyNumber',
    component: PolicyNumber
  },
  {
    path: '/qid-number',
    name: 'QidNumber',
    component: QidNumber
  },
  {
    path: '/motor/:page',
    name: 'WizardRenewMotor',
    component: WizardRenewMotor,
    props: true
  },
  {
    path: '/:filter',
    name: 'HomeFiltred',
    component: Home,
    props: true
  },
  {
    path: '/:pathMatch(.*)*',
    alias: '*',
    props: true,
    name: 'NotFound',
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: path,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

let queries = {}

router.beforeEach((to, from, next) => {
  const transIdFromQuery = to.query.transId
  if (transIdFromQuery) {
    localStorage.setItem(INITIAL_TRANS_ID_STORE_NAME, JSON.stringify(transIdFromQuery))

    const queryWithoutTransId = { ...to.query }
    delete queryWithoutTransId.transId
    next({
      path: to.path,
      query: queryWithoutTransId
    })
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  window.dispatchEvent(new Event('page-load'))

  let query = ''
  queries = { ...queries, ...from.query, ...to.query }
  const queriesKyes = Object.keys(queries)
  if (to.name !== 'Home') {
    if (queriesKyes.length) {
      for (const i in queriesKyes) {
        const key = queriesKyes[i]
        if (Number(i) === 0) {
          query = query + `?${key}=${queries[key]}`
          continue
        }
        query = query + `&${key}=${queries[key]}`
      }
      window.history.replaceState(null, null, query)
    }
  }
  if (process.env.NODE_ENV === 'development') return

  let referrer = null
  if (from !== VueRouter.START_LOCATION) {
    referrer = `${location.origin}${router.options.base.slice(0, -1)}${from.fullPath}`
  }

  notifyApi(referrer)
})

export default router
